import { SearchResultCardSkeleton } from "./search-result-card-skeleton";

const NumberOfSkeletons = 3;

export const LoadingSearchResult = () => (
    <>
        {Array(NumberOfSkeletons)
            .fill(0)
            .map((_, index) => (
                <SearchResultCardSkeleton key={index} />
            ))}
    </>
);
